import { render, staticRenderFns } from "./excel_upload_support.vue?vue&type=template&id=61d40d7e&"
import script from "./excel_upload_support.vue?vue&type=script&lang=js&"
export * from "./excel_upload_support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports